import { ModeForm } from '@mode/shared/contract-common';

export enum SupportedSyncTypes {
  Dataset = 'Dataset',
  Definition = 'Definition',
  Report = 'Report',
}

export type GithubSyncDialogData = {
  syncType: SupportedSyncTypes;
  workspace: string;
  token: string;
  defaultCommitMessage?: string;
};

export type GithubContext = {
  syncToGithubForm: ModeForm | undefined;
  githubLink: string | undefined;
  lastRunAt: string;
  lastSavedAt: string;
  lastSuccessfulSyncAt: string;
  syncTargetToken: string;
  syncTargetName: string;
  workspace: string;
};
